<template>
  <div>
    <el-row style=" margin-top: 40px;">
      <el-col :lg="7" :md="8" :sm="7" :xl="8" :xs="7" style="text-align: right;margin-right: 2%">企业微信推送：</el-col>
      <el-col :lg="10" :md="12" :sm="10" :xl="10" :xs="13">
        <el-switch
          active-color="#13ce66"
          active-text="启用"
          inactive-color="#ff4949"
          inactive-text="禁用"
          style="display: block;"
          v-model="notification.val1">
        </el-switch>
      </el-col>
    </el-row>
    <el-row class="margin-top-20" style="height: 50px">
      <el-col :lg="7" :md="8" :sm="7" :xl="8" :xs="7" style="text-align: right;margin-right: 2%">推送地址：</el-col>
      <el-col :lg="12" :md="12" :sm="14" :xl="10" :xs="13">
        <el-input placeholder="请输入企业微信推送地址"
                  size="mini"
                  v-model="notification.val2">
        </el-input>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "AlarmWechatNotification",
  props: ["alarmWechatNotification"],
  data() {
    return {
      notification: {}
    }
  },
  watch: {
    alarmWechatNotification: {
      handler() {
        this.notification = _.cloneDeep(this.alarmWechatNotification)
      },
      deep: true,
      immediate: true,
    },
    notification: {
      handler() {
        this.$emit('receiveData', this.notification)
      },
      deep: true,
    },
  },
  mounted() {
    this.notification = _.cloneDeep(this.alarmWechatNotification);
  },
}
</script>

<style scoped>

</style>

